import { DbRef, AlgoliaPlaceTag } from '@caresend/types';
import { getPlaceAccountPath, nullishFilter, arrayToObj, getPlaceGroupPath, deduplicateArray, objectFilter, formatAddressUS } from '@caresend/utils';
import '../../../database/algoliaConfig/indices.js';
import { needsNewKey, searchPlaces } from '../../../database/algoliaConfig/methods.js';
import 'firebase/auth';
import { getAlgoliaPlacesAPIKeyRequest } from '../../../database/firebaseConfig/cloudFunctions.js';
import '../../../database/firebaseConfig/init.js';
import { firebaseBind, getValueOnce, getValuesOnceByID, firebaseUnbind } from '../../../database/firebaseConfig/methods.js';
import { getElementsFromIDs } from '../../../functions/array.js';
import '@sentry/vue';
import '@fortawesome/fontawesome-svg-core';
import '@fortawesome/sharp-regular-svg-icons';
import 'buefy';
import '../../../components/ui/Icon.vue.js';
import '../../../functions/configuration/icons.js';
import 'mobile-device-detect';
import '../../../functions/tracking/index.js';
import '../../../router/helpers/initRouter.js';
import '@firebase/auth';
import 'browser-image-compression';
import 'firebase/storage';
import 'js-sha256';
import { initExtendedModule } from '../helpers.js';

/* eslint sort-keys: "error" */
const placesState = {
    bindCount: 0,
    keyData: null,
    placeAccounts: null,
    placeGroupTypes: null,
    placeGroups: null,
    places: null,
    userAssociatedPlaceID: null,
};
const placesMutations = {
    'places/RESET_PLACES': (state) => {
        state.places = null;
    },
    'places/RESET_PLACE_ACCOUNTS': (state) => {
        state.placeAccounts = null;
    },
    'places/RESET_PLACE_GROUPS': (state) => {
        state.placeGroups = null;
    },
    'places/RESET_PLACE_GROUP_TYPES': (state) => {
        state.placeGroupTypes = null;
    },
    'places/SET_ALGOLIA_KEY': (state, keyData) => {
        state.keyData = keyData;
    },
    'places/SET_PLACE': (state, place) => {
        // TODO: If we need this check, it means we have a type safety issue
        // elsewhere. Remove when possible.
        if (!place.id)
            return;
        state.places = {
            ...state.places,
            [place.id]: place,
        };
    },
    'places/SET_PLACES': (state, places) => {
        // TODO: If we need this check, it means we have a type safety issue
        // elsewhere. Remove when possible.
        if (!places)
            return;
        state.places = {
            ...state.places,
            ...places,
        };
    },
    'places/SET_PLACE_ACCOUNT': (state, placeAccount) => {
        // TODO: If we need this check, it means we have a type safety issue
        // elsewhere. Remove when possible.
        if (!placeAccount.id)
            return;
        state.placeAccounts = {
            ...state.placeAccounts,
            [placeAccount.id]: placeAccount,
        };
        if (!placeAccount.privatePlaces)
            return;
        Object.values(placeAccount.privatePlaces).forEach((place) => {
            if (!place.id)
                return;
            state.places = {
                ...state.places,
                [place.id]: place,
            };
        });
        if (!placeAccount.privatePlaceGroup || !placeAccount.placeGroupID)
            return;
        state.placeGroups = {
            ...state.placeGroups,
            [placeAccount.placeGroupID]: placeAccount.privatePlaceGroup,
        };
    },
    'places/SET_PLACE_ACCOUNTS': (state, placeAccounts) => {
        state.placeAccounts = {
            ...state.placeAccounts,
            ...placeAccounts,
        };
    },
    'places/SET_PLACE_GROUP': (state, placeGroup) => {
        // TODO: If we need this check, it means we have a type safety issue
        // elsewhere. Remove when possible.
        if (!placeGroup.id)
            return;
        state.placeGroups = {
            ...state.placeGroups,
            [placeGroup.id]: placeGroup,
        };
    },
    'places/SET_PLACE_GROUPS': (state, placeGroups) => {
        state.placeGroups = {
            ...state.placeGroups,
            ...placeGroups,
        };
    },
    'places/SET_PLACE_GROUP_TYPE': (state, placeGroupType) => {
        // TODO: If we need this check, it means we have a type safety issue
        // elsewhere. Remove when possible.
        if (!placeGroupType.id)
            return;
        state.placeGroupTypes = {
            ...state.placeGroupTypes,
            [placeGroupType.id]: placeGroupType,
        };
    },
    'places/SET_PLACE_GROUP_TYPES': (state, placeGroupTypes) => {
        // TODO: If we need this check, it means we have a type safety issue
        // elsewhere. Remove when possible.
        if (!placeGroupTypes)
            return;
        state.placeGroupTypes = {
            ...state.placeGroupTypes,
            ...placeGroupTypes,
        };
    },
    'places/SET_USER_ASSOCIATED_PLACE_ID': (state, placeID) => {
        state.userAssociatedPlaceID = placeID;
    },
    'places/UPDATE_BIND_COUNT': (state, iteration) => {
        state.bindCount += iteration;
    },
};
const placesActions = {
    // TODO: Remove if possible - excessive data fetching
    'places/bindAllPlaceData': async ({ commit, dispatch, state }) => {
        commit('places/UPDATE_BIND_COUNT', 1);
        if (state.bindCount > 1)
            return dispatch('places/fetchAllPlaceData');
        const placeGroupTypesPath = `${DbRef.PLACE_GROUP_TYPES}`;
        firebaseBind(placeGroupTypesPath, (placeGroupTypes) => {
            if (!placeGroupTypes)
                return;
            commit('places/SET_PLACE_GROUP_TYPES', placeGroupTypes);
            Object.values(placeGroupTypes).forEach((placeGroupType) => {
                dispatch('places/bindPlaceGroups', { placeGroupIDs: placeGroupType.placeGroups });
            });
        });
    },
    // TODO: Remove if possible - use fetchPlaces
    'places/bindPlaceByID': async ({ commit }, { placeID }) => {
        const placePath = `${DbRef.PLACES}/${placeID}`;
        firebaseBind(placePath, (place) => {
            if (!place)
                return;
            commit('places/SET_PLACE', place);
        });
    },
    // TODO: Remove if possible - use fetchPlaceGroups or fetchPlaces
    'places/bindPlaceGroups': async ({ commit }, { placeGroupIDs }) => {
        const promises = Object.keys(placeGroupIDs !== null && placeGroupIDs !== void 0 ? placeGroupIDs : {}).map(async (id) => {
            if (!id)
                return;
            const placeGroupPath = `${DbRef.PLACE_GROUPS}/${id}`;
            firebaseBind(placeGroupPath, (placeGroup) => {
                if (!placeGroup)
                    return;
                commit('places/SET_PLACE_GROUP', placeGroup);
            });
        });
        await Promise.all(promises);
    },
    // TODO: Remove if possible - excessive data fetching
    'places/fetchAllPlaceData': async ({ commit, dispatch }) => {
        const placeGroupTypesPath = `${DbRef.PLACE_GROUP_TYPES}`;
        const placeGroupTypes = await getValueOnce(placeGroupTypesPath);
        if (!placeGroupTypes)
            return;
        commit('places/SET_PLACE_GROUP_TYPES', placeGroupTypes);
        Object.values(placeGroupTypes).forEach((placeGroupType) => {
            var _a;
            dispatch('places/fetchPlaceGroups', {
                includePlaceGroupTypes: false,
                placeGroupIDs: Object.keys((_a = placeGroupType.placeGroups) !== null && _a !== void 0 ? _a : {}),
            });
        });
    },
    'places/fetchPlaceAccounts': async ({ commit }, placeAccountIDs) => {
        const promises = placeAccountIDs.map(async (id) => {
            if (!id)
                return;
            return getValueOnce(getPlaceAccountPath(id));
        });
        const placeAccounts = (await Promise.all(promises)).filter(nullishFilter);
        commit('places/SET_PLACE_ACCOUNTS', arrayToObj(placeAccounts, 'id'));
    },
    'places/fetchPlaceAccountsAndGroups': async ({ commit }, { placeAccountIDs, placeGroupID, }) => {
        if (!placeAccountIDs)
            return;
        const promises = placeAccountIDs.map(async (id) => {
            if (!id)
                return;
            const placeAccount = await getValueOnce(getPlaceAccountPath(id));
            if (!placeAccount)
                return;
            if (placeGroupID && placeAccount.placeGroupID !== placeGroupID)
                return;
            commit('places/SET_PLACE_ACCOUNT', placeAccount);
            if (placeAccount.placeGroupID) {
                const placeGroupPath = `${DbRef.PLACE_GROUPS}/${placeAccount.placeGroupID}`;
                const placeGroup = await getValueOnce(placeGroupPath);
                if (!placeGroup)
                    return;
                commit('places/SET_PLACE_GROUP', placeGroup);
            }
        });
        await Promise.all(promises);
    },
    'places/fetchPlaceGroupTypes': async ({ commit }, placeGroupTypeIDs) => {
        const placeGroupTypePaths = placeGroupTypeIDs.map((id) => `${DbRef.PLACE_GROUP_TYPES}/${id}`);
        const placeGroupTypes = await getValuesOnceByID(placeGroupTypePaths);
        commit('places/SET_PLACE_GROUP_TYPES', placeGroupTypes);
    },
    'places/fetchPlaceGroups': async ({ commit, dispatch }, { placeGroupIDs, includePlaceGroupTypes }) => {
        const placeGroupPaths = placeGroupIDs.map((id) => getPlaceGroupPath(id));
        const placeGroups = await getValuesOnceByID(placeGroupPaths);
        commit('places/SET_PLACE_GROUPS', placeGroups);
        if (!includePlaceGroupTypes)
            return;
        const placeGroupTypeIDs = deduplicateArray(Object.values(placeGroups).map((placeGroup) => placeGroup.placeGroupTypeID));
        await dispatch('places/fetchPlaceGroupTypes', placeGroupTypeIDs);
    },
    'places/fetchPlaces': async ({ commit, dispatch }, { placeIDs, includePlaceGroups }) => {
        const placePaths = placeIDs.map((id) => `${DbRef.PLACES}/${id}`);
        const places = await getValuesOnceByID(placePaths);
        commit('places/SET_PLACES', places);
        if (!includePlaceGroups)
            return;
        const placeGroupIDs = deduplicateArray(Object.values(places).map((place) => place.placeGroupID));
        await dispatch('places/fetchPlaceGroups', { placeGroupIDs });
    },
    'places/setUserAssociatedPlaceID': async ({ commit, state, dispatch }, location) => {
        var _a, _b, _c, _d;
        if (needsNewKey(state.keyData)) {
            await dispatch('places/updatePlacesAlgoliaKey');
        }
        const placeID = (_d = (_c = (await searchPlaces((_b = (_a = state.keyData) === null || _a === void 0 ? void 0 : _a.key) !== null && _b !== void 0 ? _b : '', '', {
            aroundLatLng: `${location.lat}, ${location.lng}`,
            aroundRadius: 1609,
            filters: `_tags:${AlgoliaPlaceTag.MANAGES_INVENTORY}`,
        }))[0]) === null || _c === void 0 ? void 0 : _c.id) !== null && _d !== void 0 ? _d : false;
        commit('places/SET_USER_ASSOCIATED_PLACE_ID', placeID);
        if (placeID) {
            await dispatch('places/fetchPlaces', { includePlaceGroups: true, placeIDs: [placeID] });
        }
        return placeID;
    },
    // TODO: Remove if possible - excessive data fetching
    'places/unbindAllPlaceData': ({ commit, state }) => {
        commit('places/UPDATE_BIND_COUNT', -1);
        if (state.bindCount > 0)
            return;
        const placeGroupTypesPath = `${DbRef.PLACE_GROUP_TYPES}`;
        firebaseUnbind(placeGroupTypesPath);
    },
    'places/updatePlacesAlgoliaKey': async ({ commit }) => {
        const keyData = await getAlgoliaPlacesAPIKeyRequest();
        commit('places/SET_ALGOLIA_KEY', keyData);
    },
};
const placesGetters = {
    'places/getLabsPlaceGroupType': (state) => {
        var _a, _b;
        return (_b = Object.values((_a = state.placeGroupTypes) !== null && _a !== void 0 ? _a : {})
            .find((placeGroupType) => placeGroupType.name.toLowerCase().includes('lab'))) !== null && _b !== void 0 ? _b : null;
    },
    'places/getOfficePlaceAccounts': (state, _getters, rootState) => (officeID) => {
        var _a, _b, _c, _d, _e;
        const labPlaceGroupID = (_a = rootState.office.office) === null || _a === void 0 ? void 0 : _a.placeGroupID;
        const accounts = (_e = (_d = (_c = (_b = rootState.offices) === null || _b === void 0 ? void 0 : _b.offices) === null || _c === void 0 ? void 0 : _c[officeID]) === null || _d === void 0 ? void 0 : _d.sharedPlaceAccounts) !== null && _e !== void 0 ? _e : {};
        const filteredAccounts = objectFilter(accounts, (account) => {
            var _a;
            const placeAccount = (_a = state.placeAccounts) === null || _a === void 0 ? void 0 : _a[account.id];
            return (placeAccount === null || placeAccount === void 0 ? void 0 : placeAccount.placeGroupID) === labPlaceGroupID;
        });
        return placesGetters['places/getSortedPlaceAccountsByIDs'](state)(filteredAccounts);
    },
    'places/getPlaceAccountByID': (state) => (placeAccountID) => { var _a, _b; return (_b = (_a = state.placeAccounts) === null || _a === void 0 ? void 0 : _a[placeAccountID !== null && placeAccountID !== void 0 ? placeAccountID : '']) !== null && _b !== void 0 ? _b : null; },
    'places/getPlaceAddress': (state) => (placeID) => {
        var _a, _b;
        const place = (_b = (_a = state.places) === null || _a === void 0 ? void 0 : _a[placeID]) !== null && _b !== void 0 ? _b : null;
        if (!place)
            return null;
        return formatAddressUS(place.location);
    },
    'places/getPlaceByPlaceID': (state) => (placeID) => {
        var _a, _b;
        if (!placeID)
            return null;
        return (_b = (_a = state.places) === null || _a === void 0 ? void 0 : _a[placeID]) !== null && _b !== void 0 ? _b : null;
    },
    'places/getPlaceGroupByPlace': (state) => (place) => {
        var _a, _b;
        const { placeGroupID } = place;
        return (_b = (_a = state.placeGroups) === null || _a === void 0 ? void 0 : _a[placeGroupID]) !== null && _b !== void 0 ? _b : null;
    },
    'places/getPlaceGroupByPlaceAccount': (state) => (placeAccount) => {
        var _a, _b;
        if (!placeAccount)
            return null;
        let placeGroup = null;
        if (placeAccount === null || placeAccount === void 0 ? void 0 : placeAccount.privatePlaceGroup)
            placeGroup = placeAccount.privatePlaceGroup;
        else if (placeAccount === null || placeAccount === void 0 ? void 0 : placeAccount.placeGroupID)
            placeGroup = (_b = (_a = state.placeGroups) === null || _a === void 0 ? void 0 : _a[placeAccount.placeGroupID]) !== null && _b !== void 0 ? _b : null;
        return placeGroup;
    },
    'places/getPlaceGroupByPlaceID': (state) => (placeID) => {
        var _a;
        const place = (_a = state.places) === null || _a === void 0 ? void 0 : _a[placeID !== null && placeID !== void 0 ? placeID : ''];
        if (!place)
            return null;
        return placesGetters['places/getPlaceGroupByPlace'](state)(place);
    },
    'places/getPlacesOnPlaceGroup': (state) => (placeGroupID) => {
        var _a, _b, _c;
        const placeIDs = Object.keys((_c = (_b = (_a = state.placeGroups) === null || _a === void 0 ? void 0 : _a[placeGroupID]) === null || _b === void 0 ? void 0 : _b.places) !== null && _c !== void 0 ? _c : {});
        return getElementsFromIDs(placeIDs, (id) => { var _a; return (_a = state.places) === null || _a === void 0 ? void 0 : _a[id]; }, 'place');
    },
    'places/getSortedPlaceAccountsByIDs': (state) => (placeGroupIDs) => {
        const accountMap = (element) => { var _a; return (_a = state.placeAccounts) === null || _a === void 0 ? void 0 : _a[element.id]; };
        const accountSort = (labA, labB) => { var _a, _b; return ((_a = labA.placeGroupID) !== null && _a !== void 0 ? _a : '') < ((_b = labB.placeGroupID) !== null && _b !== void 0 ? _b : '') ? -1 : 1; };
        return Object.values(placeGroupIDs)
            .map(accountMap)
            .filter(nullishFilter)
            .sort(accountSort);
    },
    'places/getUserAndOfficePlaceAccounts': (state, _getters, rootState) => {
        var _a, _b, _c, _d;
        const accounts = {
            ...(_b = (_a = rootState.auth) === null || _a === void 0 ? void 0 : _a.user) === null || _b === void 0 ? void 0 : _b.placeAccounts,
            ...(_d = (_c = rootState.office) === null || _c === void 0 ? void 0 : _c.office) === null || _d === void 0 ? void 0 : _d.sharedPlaceAccounts,
        };
        return placesGetters['places/getSortedPlaceAccountsByIDs'](state)(accounts);
    },
};
const placesModule = {
    actions: placesActions,
    getters: placesGetters,
    mutations: placesMutations,
    state: placesState,
};
const initPlacesModule = (moduleExtensions) => initExtendedModule(placesModule, moduleExtensions);

export { initPlacesModule };
